// the purpose of sessionStorageEx is to safely abstract session storage
// import { Config, BUILD_TYPE } from 'utils/webappConfig';

const dataKeys = Object.freeze({
  authSession: 'auth_session',
  entitlements: 'entitlements',
  sessionState: 'session_state',

  // ^^^ add your new key above
});

function setItem(key, value) {
  if (value === undefined) {
    removeItem(key);
  } else {
    const jsonValue = JSON.stringify(value);
    try {
      sessionStorage.setItem(key, jsonValue);
    } catch (e) {
      assert(false, `can't save session data ${key} = ${value}\n${e}`);
    }
  }
}

function getItem(key) {
  let value;

  try {
    const jsonValue = sessionStorage.getItem(key);
    value = JSON.parse(jsonValue);
  } catch (e) {
    assert(false, `can't get session data for "${key}"\n${e}`);
  }

  return value;
}

function removeItem(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    assert(false, `can't delete session data for "${key}"\n${e}`);
  }
}

export const getSessionState = () => getItem(dataKeys.sessionState);
export const setSessionState = (value) => setItem(dataKeys.sessionState, value);
export const removeSessionState = () => removeItem(dataKeys.sessionState);

export const getAuthSession = () => getItem(dataKeys.authSession);
export const setAuthSession = (value) => setItem(dataKeys.authSession, value);
export const removeAuthSession = () => removeItem(dataKeys.authSession);

export const getEntitlements = () => getItem(dataKeys.entitlements);
export const setEntitlements = (value) => setItem(dataKeys.entitlements, value);
export const removeEntitlemets = () => removeItem(dataKeys.entitlements);

